import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VideoData } from '../../../interfaces';

@Component({
  selector: 'app-youtube-video-modal',
  templateUrl: './youtube-video-modal.component.html',
  styleUrls: ['./youtube-video-modal.component.scss']
})
export class YoutubeVideoModalComponent implements OnInit {
  sanitizedVideoUrl!: SafeResourceUrl;

  constructor(
    private readonly sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<YoutubeVideoModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: VideoData
  ) {}

  ngOnInit() {
    this.sanitizedVideoUrl = this.getSafeUrl(this.data.videoId);
  }

  getSafeUrl(videoId: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}?rel=0`);
  }

  linkify(text: string): SafeHtml {
    const urlRegex = /((https?:\/\/)[^\s]+)/g;
    const html = text.replace(urlRegex, (url) => {
      const displayUrl = url.replace(/<\/?[^>]+(>|$)/g, '');
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${displayUrl}</a>`;
    });
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
